// Direct file import (not the @modules/items barrel) to avoid circular-init crashes - this helper is
// imported widely across modules.
import splitExtension from '@modules/items/helpers/splitExtension.helper';

// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/items/src/constants.ts
const HIDDEN_REFERENCE_DISPLAY_EXTENSIONS = new Set(['pdf', 'docx']);

/** Strip hidden reference display extensions from a name; leave every other extension intact. */
export const stripHiddenReferenceDisplayExtension = (itemName: string): string => {
  const [base, extension] = splitExtension(itemName);
  return HIDDEN_REFERENCE_DISPLAY_EXTENSIONS.has(extension.toLowerCase()) ? base : itemName;
};

/**
 * Display label for a referenced item. The decision is name-based and matches the backend: hide only
 * the configured reference display extensions and leave extensionless names untouched.
 */
const getReferenceItemLabel = (itemName: string): string => stripHiddenReferenceDisplayExtension(itemName);

export default getReferenceItemLabel;
